"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionErrorMessage = void 0;
var DistributionErrorMessage;
(function (DistributionErrorMessage) {
    DistributionErrorMessage["NotFound"] = "Distribution not found";
    DistributionErrorMessage["InvalidStatusForCancellation"] = "The current distribution status is not valid for cancellation";
    DistributionErrorMessage["DistributionNotSupported"] = "Distribution not supported";
})(DistributionErrorMessage || (exports.DistributionErrorMessage = DistributionErrorMessage = {}));
